/*!
 * @author electricessence / https://github.com/electricessence/
 * Licensing: MIT https://github.com/electricessence/TypeScript.NET/blob/master/LICENSE.md
 */
define(["require", "exports", "./IteratorResult", "../../Functions"], function (require, exports, IteratorResult_1, Functions_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var VOID0 = void 0;
    /**
     * A simplified stripped down enumerable that is always complete and has no results.
     * Frozen and exported as 'empty' to allow for reuse.
     */
    exports.EmptyEnumerator = Object.freeze({
        current: VOID0,
        moveNext: Functions_1.Functions.False,
        tryMoveNext: Functions_1.Functions.False,
        nextValue: Functions_1.Functions.Blank,
        next: IteratorResult_1.IteratorResult.GetDone,
        "return": IteratorResult_1.IteratorResult.GetDone,
        end: Functions_1.Functions.Blank,
        reset: Functions_1.Functions.Blank,
        dispose: Functions_1.Functions.Blank,
        isEndless: false
    });
    exports.default = exports.EmptyEnumerator;
});
